import { FC, useContext } from 'react';
import { useUserIsLogged } from '@common/selectors/user.selectors';
import { trans } from '../../modules/translation/translate';
import { NotificationIcon } from '../notificationIcon/NotificationIcon';
import { SettingsLayoutContext } from './SettingsLayout.context';

export const SettingsLayoutDesktop: FC = () => {
	const {
		sections,
		activeId,
		activeTabData,
		getSectionContent,
		handleChangeSection,
	} = useContext(SettingsLayoutContext);
	const isLogged = useUserIsLogged();

	return (
		<div className="settings">
			<div className="settings__menu">
				{sections.map((el) => {
					if ((el.isActive && !el.isActive()) || (!isLogged && el.isLogged)) {
						return null;
					}
					const className =
						activeId === el.id ? 'active settings__button' : 'settings__button';
					return (
						<span
							key={el.id}
							className={`${className} ${el.id}`}
							onClick={() => handleChangeSection(el)}
						>
							<span className="relative">
								{el.name && <>{trans({ label: el.name() })} </>}
								{el.nameComponent && <>{el.nameComponent()} </>}
								{!!el.notification && (
									<NotificationIcon notification={el.notification} />
								)}
							</span>
						</span>
					);
				})}
			</div>
			{activeId &&
				getSectionContent(
					activeId,
					activeTabData?.panelTitle,
					activeTabData?.isNarrow,
				)}
		</div>
	);
};
